import { GQLPhotoItemFragment } from 'components/page/ForeignProfile/gql/__generated__/Photos'

export const cachePhotos = (photos: GQLPhotoItemFragment[]) => {
  return (
    photos
      /** https://sentry.mamba.ru/organizations/mamba/issues/322610/?project=6&query=is%3Aunresolved */
      .filter(Boolean)
      .reduce((acc, { urls: { xHuge, huge } }) => {
        if (xHuge) {
          return [...acc, xHuge]
        }

        return [...acc, huge]
      }, [])
      .map((photo) => {
        const img = new Image()
        img.src = photo
      })
  )
}
